import React from 'react';
import { Alert } from '@mui/material';
import { rbacStrings } from '../../../rbac';

// Bandeau non bloquant : le droit planbt.edit a été retiré alors que des
// modifications locales n'étaient pas enregistrées. Rien n'est affiché sinon.
export const EditRightsRevokedBanner: React.FC<{ count: number }> = ({ count }) => {
  if (count <= 0) return null;
  return (
    <Alert severity="warning" role="alert">
      {rbacStrings.editRightsRevokedUnsaved(count)}
    </Alert>
  );
};

export default EditRightsRevokedBanner;
